// extracted by mini-css-extract-plugin
export default {"modal":"leaders-share-modal_modal__Zf1iJ","cellInModal":"leaders-share-modal_cellInModal__XRH+u"};